setLiveAccessEventDetails